import { FC } from 'react';
import { TelemetryModel } from '@/lib/models/telemetry/telemetry.model';
import { getTypedTelemetry } from '@/lib/models/telemetry';
import { Stack } from '@mui/material';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import Icon from '../icon';

interface Props {
  telemetry: TelemetryModel;
  size?: 'small' | 'large';
  className?: string;
}

const Sizes = {
  small: { width: 40, height: 35 },
  large: { width: 60, height: 50 },
};

const useStyles = createUseStyles<string, { width: number; height: number }>({
  telemetryIcon: ({ height, width }) => ({
    height,
    width,
    overflow: 'hidden',
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      width: 'auto',
      height: 'auto',
    },
  }),
});

const TelemetryIcon: FC<Props> = ({ telemetry, size = 'small', className = '' }) => {
  const typedTelemetry = getTypedTelemetry(telemetry);
  const { iconImage, icon } = typedTelemetry;
  const { width, height } = Sizes[size];
  const hasImage = !!iconImage;
  const styles = useStyles({ width, height });
  const compClass = classNames(styles.telemetryIcon, className);

  return (
    <Stack alignItems="center" justifyContent="center" className={compClass}>
      {hasImage ? (
        <img src={iconImage} alt={typedTelemetry.type} />
      ) : (
        <Icon name={icon || 'telemetry'} />
      )}
    </Stack>
  );
};

export default TelemetryIcon;
